export const EDIT = 'EDIT';
export const EDIT_WITHOUT_YIELD = 'EDIT_WITHOUT_YIELD';
export const OWNER = 'OWNER';
